module.exports = __webpack_public_path__ + "static/media/picoline-white.3015d793.svg";